
// List of constant images
// ---- aboutScreen
export const kAboutScreenImages = {
    letterFox: 'images/aboutScreen/letterFoxIllustration.png',
    missionFox: '/images/aboutScreen/AboutMissionFoxIllustration.png',
}

// ---- brevetScreen
export const kBrevetScreenImages = {
    // ---- screen info
    screenInfoImage: "/images/screens/brevetScreenFox.png",
}

// ---- Exercisers
export const kExerciserImages = {
    logoText: '/images/SystemExerciserLogoText.png',
}

// ---- flashScreen
export const kFlashImages = {
    logoText: '/images/SystemFlashLogoText.png',
    noGradeSelected: "/images/courses/CoursesBookIllustration.png",
}

// ---- Games
export const kGamesImages = {
    // ---- screen info
    screenInfoImage: "/images/screens/gamesScreenFox.png",
    // ---- others
    looseImage: "/images/fox/SystemConfusedFox.png",
    recordImage: "/images/fox/SystemStarsFox.png",
    successImage: "/images/fox/SystemHappyFox.png",
}

// ---- glossaryScreen
export const kGlossaryImages = {
    // ---- screen info
    screenInfoImage: "/images/screens/glossaryScreenFox.png",
}

// ---- homeScreen
export const kHomeScreenImages = {
    foxWithPhone: "/images/homeScreen/HomePhoneIllustration.png",
}

// ---- SYSTEM
export const kSystemImages = {
    // Fox emojis
    approvingFox: "/images/fox/SystemApprovingFox.png",
    blinkingFox: "/images/fox/SystemBlinkingFox.png",
    confusedFox: "/images/fox/SystemConfusedFox.png",
    cryingFox: "/images/fox/SystemCryingFox.png",
    happyFox: "/images/fox/SystemHappyFox.png",
    lovingFox: "/images/fox/SystemLovingFox.png",
    scepticalFox: "/images/fox/SystemScepticalFox.png",
    starsFox: "/images/fox/SystemStarsFox.png",
    // Fox
    emptyResultFox: "/images/SystemEmptyResultFox.png",
    // Others
    flashLogo: "/images/SystemFlashLogo.png",
    getItOnAppStore: "/images/SystemGetItOnAppStore.png",
    getIsOnPlayStore: "/images/SystemGetItOnPlayStore.png",
    dividerStar: "/images/SystemQuestionDividerStar.png",
    routeNotFound: "/images/SystemEmptyResultFox.png",
    neoUmmiaLogo: '/images/SystemUmmiaLogo.png',
    neoUmmiaLogoText: '/images/SystemUmmiaNeoLogoText.png',
    neoUmmiaDarkLogoText: '/images/SystemUmmiaNeoDarkLogoText.png',
}